import { render, staticRenderFns } from "./DeviceAdoption.vue?vue&type=template&id=646b331c"
import script from "./DeviceAdoption.vue?vue&type=script&lang=js"
export * from "./DeviceAdoption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports